/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button } from '@chakra-ui/react';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactExport from 'react-export-excel';
import { useTranslation } from 'react-i18next';
import c from '../../../constant';
import { fileNameEWS } from '../Miscellaneous/export';
import useStore from '../../../store';
import { useMemo } from 'react';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function AnnuallyExcelSummarizedReportSPLOCI({ object = null, ...props }) {
	const { t } = useTranslation();

	const currentLang = useStore((state) => state.currentLang);

	const tables = object?.tables || [];
	const labels = object?.labels || [];

	const data = useMemo(() => {
		if (!labels.length || !tables.length) return [];

		return labels.map((label, rowIdx) => {
			const row = {
				title: currentLang === 'kh' ? label?.titleKhmer : label?.titleEnglish,
			};

			tables.forEach((table) => {
				const year = table?.key;
				row[`${year}_USD`] = table?.tableCells?.[rowIdx]?.[0]?.value ?? '';
				row[`${year}_KHR000`] = table?.tableCells?.[rowIdx]?.[1]?.value ?? '';
			});

			return row;
		});
	}, [labels, tables, currentLang]);

	return (
		<Box {...props}>
			<ExcelFile
				filename={fileNameEWS(`SPLOCI_Annually Unaudited Financial Summarized Report`, null, null)}
				element={
					<Button
						leftIcon={<FontAwesomeIcon icon={faFileExcel} style={{ fontSize: 16 }} />}
						colorScheme="gray"
						variant="solid"
						size="sm"
						borderRadius={c.borderRadius}
						border="1px solid #bdc3c7"
					>
						{t('Export')}
					</Button>
				}
			>
				<ExcelSheet data={data} name="SPLOCI">
					<ExcelColumn label={t('Label')} value="title" />

					{tables?.map((tb) => {
						const year = tb?.key;
						return [
							<ExcelColumn key={`${year}-usd`} label={`${year}_USD`} value={`${year}_USD`} />,
							<ExcelColumn key={`${year}-khr`} label={`${year}_KHR'000`} value={`${year}_KHR000`} />,
						];
					})}
				</ExcelSheet>
			</ExcelFile>
		</Box>
	);
}
